module.exports = __webpack_public_path__ + "assets/d07d0cd130485bd6ec871b5e1998bba9.svg";